export { default as isAttachmentFeatureEnabled } from './isAttachmentFeatureEnabled';
export { default as attachmentFeatures } from './attachmentFeatures';
//# sourceMappingURL=index.js.map